import { createDecorator } from "../../instantiation/common/registry";

export const IAnalyticsService = createDecorator<IAnalyticsService>("analyticsService");

export interface IAnalyticsService {

    /** Report a handled editor failure through the error pipeline. */
    logError(error: unknown, context?: Record<string, unknown>): void;

    logEvent(eventName: string, params?: { [key: string]: any }): void;

}